import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LiveTransactionState } from "../../types";
import { axiosObj } from "../../../config/apiClients";
import { LiveTransaction } from "../../../utils/types";
import { queryParams } from "../../../utils/interface";
import { buildUrlWithParams } from "../../../utils/helpers/common";
import { formatDuration } from "../../../utils/date";

const initialState: LiveTransactionState = {
  isLoading: false,
  liveTransactions: [],
  goldPrice: {
    MDBuyingPx: 0,
    MDSellingPx: 0
  },
  pagination: {
    totalItems: 0,
    currentPage: 1,
    totalPages: 1,
    hasNextPage: false
  }
};

export const getLiveTransactions = createAsyncThunk(
  "/liveTransactions",
  async (query: queryParams, { rejectWithValue }) => {
    try {
      const url = buildUrlWithParams("liveTransactions", query);
      const response = await axiosObj.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Live Transactions' });
    }
  }
);

const liveTransactionsSlice = createSlice({
  name: "liveTransactions",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getLiveTransactions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLiveTransactions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.liveTransactions = action.payload?.payload.liveTransactions.map((item: LiveTransaction) => ({
          ...item,
          dealId: item.dealId ? item.dealId : '-',
          closePrice: item.closePrice ? item.closePrice : null,
          moneyBalance: item.moneyBalance ? item.moneyBalance : undefined,
          metalBalance: item.metalBalance ? item.metalBalance : undefined,
          timeDiff: item.typeDetail === "Trade" ? formatDuration(item.timeDiff) : "-",
          totalPnl: item.totalPnl ? item.totalPnl : null
        }));
        state.pagination = {
          totalItems: action.payload.payload.totalItems,
          currentPage: action.payload.payload.page,
          totalPages: action.payload.payload.totalPages,
          hasNextPage: action.payload.payload.hasNextPage
        };
      })
      .addCase(getLiveTransactions.rejected, (state) => {
        state.isLoading = false;
        state.liveTransactions = [];
      })
  }
})

export default liveTransactionsSlice.reducer;